/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscalecomplexemotionsstrong4Inputs */



/**
* | output |
* | --- |
* | "You can tell apart complex and ambiguous emotions, understand what causes them and describe your own state more precisely." |
*
* @param {Eisubscalecomplexemotionsstrong4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscalecomplexemotionsstrong4 = /** @type {((inputs?: Eisubscalecomplexemotionsstrong4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscalecomplexemotionsstrong4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You can tell apart complex and ambiguous emotions, understand what causes them and describe your own state more precisely.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sabes distinguir emociones complejas y ambiguas, entiendes sus causas y puedes describir tu estado con más precisión.")
	return /** @type {LocalizedString} */ ("Ты умеешь различать сложные и неоднозначные эмоции, понимаешь их причины и можешь точнее описать своё состояние.")
});
export { eisubscalecomplexemotionsstrong4 as "eiSubscaleComplexEmotionsStrong" }